import {jwtDecode} from 'jwt-decode';

import {getAccessToken, setAccessToken, setProfile} from "@/Foundation/helpers/storage";
import Server from '@/Foundation/plugins/server';

export default {
  namespaced: true,
  state: {
    signInUrls: null,
    signedIn: false,
    user: null,
    signInError: null,
  } as {
    signInUrls: null | { github?: string, openid?: string },
    signedIn: boolean,
    user: null | {},
    signInError: null | string
  },
  mutations: {
    gotSignInUrls(state, urls) {
      state.signInUrls = urls;
    },
    identified(state, access_token) {
      state.signedIn = true;
      state.user = jwtDecode(access_token);
    },
    identifyError(state, query) {
      state.signInError = query.data;
    },
    logout(state) {
      state.signedIn = false;
      state.user = null;
    },
  },
  actions: {
    async authorizeGithub({commit, dispatch}, githubAccessToken) {
      const result = await Server.post('/api/authorize', {
        data: {
          github_access_token: githubAccessToken
        }
      });
      if (!!result.data?.access_token) {
        setAccessToken(result.data.access_token);
        setProfile(result.data.name, result.data.color, result.data.roles)
        commit('identified', result.data.access_token);
      } else {
        commit('identifyError', result);
      }
    },
    async authorizeOpenid({commit, dispatch}, openidAccessToken) {
      const result = await Server.post('/api/authorize', {
        data: {
          openid_access_token: openidAccessToken
        }
      });
      if (!!result.data?.access_token) {
        setAccessToken(result.data.access_token);
        setProfile(result.data.name, result.data.color, result.data.roles)
        commit('identified', result.data.access_token);
      } else {
        commit('identifyError', result);
      }
    },
    async identify({commit}) {
      const accessToken = getAccessToken();
      if (accessToken) {
        commit('identified', accessToken);
      }
    },
    async getSignInUrls({commit}) {
      const result = await Server.get('/api/sign-in-url');
      commit('gotSignInUrls', result.data?.urls);
    }
  },
};
